import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import contextSportsHeader from '@contexts/sportsHeader'
import { SportsHeaderContextType } from '@contexts/sportsHeader'
import { HorizontalRankingProps } from '@widgets/Teaser/sportsHeader/types'
import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import HorizontalRankingItem from './RankingItem'

type StyledHorizontalRanking = Pick<SportsHeaderContextType, 'teaserFlex'>

const { SportsHeaderContext } = contextSportsHeader

const StyledHorizontalRanking = styled.div<StyledHorizontalRanking>`
  ${({ teaserFlex }) => {
    let paddingLeftDesktop
    let gridColumnGapDesktop
    const desktopTeaserFlex = teaserFlex['desktop']
    if (desktopTeaserFlex === '6') {
      paddingLeftDesktop = '20px'
      gridColumnGapDesktop = '40px'
    } else if (desktopTeaserFlex === '4') {
      paddingLeftDesktop = '20px'
      gridColumnGapDesktop = '40px'
    } else if (desktopTeaserFlex === '3') {
      paddingLeftDesktop = '10px'
      gridColumnGapDesktop = '20px'
    }

    let paddingLeftTablet
    let gridColumnGapTablet
    const tabletTeaserFlex = teaserFlex['tablet']
    if (tabletTeaserFlex === '6') {
      paddingLeftTablet = '20px'
      gridColumnGapTablet = '40px'
    } else if (tabletTeaserFlex === '3') {
      paddingLeftTablet = '10px'
      gridColumnGapTablet = '20px'
    }

    return css`
      display: grid;
      grid-auto-flow: column;
      grid-template-columns: repeat(3, max-content);
      align-items: center;
      justify-items: flex-start;
      width: 100%;
      box-sizing: border-box;
      padding-top: 6px;
      padding-bottom: 6px;

      ${desktopCSS(css`
        ${desktopTeaserFlex === '2' &&
        css`
          display: none;
        `}

        ${desktopTeaserFlex !== '2' &&
        css`
          padding-left: ${paddingLeftDesktop};
          padding-right: ${parseInt(paddingLeftDesktop || '', 10) / 2}px;
          grid-column-gap: ${gridColumnGapDesktop};
        `}
      `)}

      ${tabletCSS(css`
        padding-left: ${paddingLeftTablet};
        padding-right: ${parseInt(paddingLeftTablet || '', 10) / 2}px;
        grid-column-gap: ${gridColumnGapTablet};
      `)}

      ${mobileCSS(css`
        display: none;
      `)}
    `
  }}
`

const HorizontalRanking: FunctionComponent<HorizontalRankingProps> = ({
  competitors,
}) => {
  const { teaserFlex } = useContext(SportsHeaderContext)

  return (
    <StyledHorizontalRanking teaserFlex={teaserFlex}>
      {competitors.map((competitor) => (
        <HorizontalRankingItem key={competitor.name} competitor={competitor} />
      ))}
    </StyledHorizontalRanking>
  )
}

export default HorizontalRanking
